import moment from "moment";
import Week = DateUtils.Week;
import DateRange = DateUtils.DateRange;

export class DateUtils {
    private static formatDate(
        fromFormat: string,
        toFormat: string,
        date?: string
    ): string {
        var res = "";

        var dateObj = moment(date, fromFormat);

        if (dateObj.isValid()) {
            res = dateObj.format(toFormat);
        }

        return res;
    }

    static dateStrToSql(
        date?: string,
        customFormat: string = "DD/MM/YYYY"
    ): string {
        return this.formatDate(customFormat, "YYYY-MM-DD", date);
    }

    static sqlToDateStr(
        date?: string | null,
        customFormat: string = "DD/MM/YYYY"
    ): string {
        return this.formatDate(
            "YYYY-MM-DDThh:mm:ssZ",
            customFormat,
            date ? date : undefined
        );
    }

    static weekToDateRange(week: Week): DateRange {
        let date = moment(week.year + "-" + week.week, "YYYY-W");
        return {
            start: date.format("YYYY-MM-DD"),
            end: date.add(6, "d").format("YYYY-MM-DD"),
        };
    }

    static weeksToDateRange(startWeek: Week, endWeek?: Week): DateRange {
        return {
            start: this.weekToDateRange(startWeek).start,
            end: endWeek
                ? this.weekToDateRange(endWeek).end
                : this.weekToDateRange(startWeek).end,
        };
    }
}

export namespace DateUtils {
    export interface Week {
        year: Number;
        week: Number;
    }

    export interface Month {
        year: Number;
        month: Number;
    }

    export interface DateRange {
        start: string;
        end: string;
    }

    export enum EWeekDays {
        monday = 1,
        tuesday = 2,
        wednesday = 3,
        thursday = 4,
        friday = 5,
        saturday = 6,
        sunday = 0,
    }

    export const WeekDays = {
        [EWeekDays.monday]: { id: EWeekDays.monday, name: "Lundi" },
        [EWeekDays.tuesday]: { id: EWeekDays.tuesday, name: "Mardi" },
        [EWeekDays.wednesday]: { id: EWeekDays.wednesday, name: "Mercredi" },
        [EWeekDays.thursday]: { id: EWeekDays.thursday, name: "Jeudi" },
        [EWeekDays.friday]: { id: EWeekDays.friday, name: "Vendredi" },
        [EWeekDays.saturday]: { id: EWeekDays.saturday, name: "Samedi" },
        [EWeekDays.sunday]: { id: EWeekDays.sunday, name: "Dimanche" },
    };

    export enum EMonths {
        january = 1,
        february,
        march,
        april,
        may,
        june,
        july,
        august,
        september,
        october,
        november,
        december,
    }

    export const Months = {
        [EMonths.january]: { id: EMonths.january, name: "Janvier" },
        [EMonths.february]: { id: EMonths.february, name: "Février" },
        [EMonths.march]: { id: EMonths.march, name: "Mars" },
        [EMonths.april]: { id: EMonths.april, name: "Avril" },
        [EMonths.may]: { id: EMonths.may, name: "Mai" },
        [EMonths.june]: { id: EMonths.june, name: "Juin" },
        [EMonths.july]: { id: EMonths.july, name: "Juillet" },
        [EMonths.august]: { id: EMonths.august, name: "Aout" },
        [EMonths.september]: { id: EMonths.september, name: "Septembre" },
        [EMonths.october]: { id: EMonths.october, name: "Octobre" },
        [EMonths.november]: { id: EMonths.november, name: "Novembre" },
        [EMonths.december]: { id: EMonths.december, name: "Décembre" },
    };
}
